import { render, staticRenderFns } from "./BookmakerPromotionsList.vue?vue&type=template&id=6cf74adb&"
import script from "./BookmakerPromotionsList.vue?vue&type=script&lang=ts&"
export * from "./BookmakerPromotionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports